import { render, staticRenderFns } from "./uf_main_competitor_abroad.vue?vue&type=template&id=fd7ec2f0&scoped=true"
import script from "./uf_main_competitor_abroad.vue?vue&type=script&lang=js"
export * from "./uf_main_competitor_abroad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7ec2f0",
  null
  
)

export default component.exports